import getURLContents from './graphql/queries/getURLContents';

const urlContentsModels = {
  getURLContents(url) {
    return getURLContents(url);
  },
};

export default urlContentsModels;
